<template>

<div class="page" id="configuracion">
        <side-menu :menuOn="menuOn"  @menuVisible="menuVisible"></side-menu>
        <mnavbar @menuVisible="menuVisible"></mnavbar>
        <div class="texture"></div>
        <section class="account-section">
            <div class="container-fluid">
                <h1 class="section-title">Configuración</h1>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6 col-lg-4" >
                        <perfil @changeBanner="changeBanner"  @changeAvatar="changeAvatar" :item="item" @updateItem="updateItem"></perfil><!--Mi cuenta-->
                    </div>
                    <div class="col-12 col-md-6  col-lg-4" >
                        <admin-redes></admin-redes><!--Integración de redes-->
                    </div>
                    <div class="col-12 col-md-6  col-lg-3">
                        <alertas></alertas>
                        <div class="mt-4"></div>
                        <filtros></filtros>
                    </div>
                </div>
            </div>
            <div class="spacer-height"></div>
        </section>
</div>
</template>
<script>

import SideMenu from '@/components/sideMenu'
import mnavbar from '@/components/mnavbar'
import perfil from '@/components/perfil/main'
import adminRedes from '@/components/perfil/redes'
import alertas from '@/components/perfil/alertas'
import filtros from '@/components/perfil/filtros'
import firebase from 'firebase';


export default {
    components: {mnavbar,perfil,adminRedes,alertas,filtros,SideMenu},
    data () {
        return{
            menuOn:false,
            url:this.$store.getters.getMainUrl,
            providerID:this.$store.state.userInfo.net,
            banner:'../../public/assets/img/banner.png',
            bannerImage : '',
            BannerFile:'',
            item:{}
        }
    },
    computed:{
        token(){
            return this.$store.getters.getToken;
        }
    },
    mounted(){
        //this.init();
        this.getInfoUser();
    },
    methods:{
        async init() {
            this.token =  this.token;
            var user = await this.$store.getters.getCurrentUser;
            this.providerID = user.providerData[0].providerId;
            this.getInfoUser();
        }, 
        getInfoUser(){
            console.log('getInfoUser')
            var post_data = {
                cmd: "getInfoUser",
                data: {
                    token: this.token,
                    providerID: this.providerID
                }
            };
            var self = this;
            axios.post(this.url+'UsersBdtr', JSON.stringify(post_data)) //petición
            .then((response)=>{
                if(response.data.success){
                    self.item = response.data.data;
                }
            })
            .catch(function (error) {
                var response = {success:false,error:error}
                console.log(error);
            });
        },
        changeBanner(newBanner){
            this.item['banner'] = newBanner;
        },
        changeAvatar(newAvatar){
            this.item['imagen'] = newAvatar;
        },
        updateItem(item){
            if(item.imagen)
                this.$store.state.userInfo.imagen = item.imagen;
            if(item.banner)
                this.$store.state.userInfo.banner = item.banner;
        },
        menuVisible(menu){
            this.menuOn = menu;
        },
        menuVisible(menu){
            this.menuOn = menu;
        }
    }
}


</script>

<style scoped>
.spacer-height {
    height: 100px;
}
</style>
